<template>
  <div style="position:relative;">
    <div class="left" v-if="scrollable.left">
      <div class="button left-button" @click="tabScroll(false)">
        <i class="el-icon-arrow-left"></i>
      </div>
    </div>
    <div class="right" v-if="scrollable.right">
      <div class="button right-button" @click="tabScroll(true)">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="scroll-box">
      <div class="group" id="group" :style="scrollStyle">
        <div v-for="(item,index) in list" :key="item.id" class="item" :class="{'is_active':currentIndex === index}"
             @click="itemCLick(item, index)">
          {{ item.code }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FBAWarehouseSelect",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    defaultId: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      leftScrollDistance: 0,
      clientWidth: 0,
      scrollWidth: 0,
      currentIndex: -1,
      translateX: 0,
      boxWidth: 1200,
      leftPadding: 40,
      boxMarginRight: 40,
      currentScrollIndex: 0,
      scrollable: {
        left: false,
        right: false
      }
    }
  },
  computed: {
    scrollStyle(){
      return `transform: translateX(${-this.translateX}px);`;
    },
    maxIndex(){
      let l =  this.list.length || 0;
      if(l>=3) l -= 2;
      return l;
    },
  },
  methods: {
    /**
     * 左右滑动
     * @param toRight {Boolean}
     */
    tabScroll(toRight) {
      let index = this.currentScrollIndex;
      let x = this.translateX;
      if (toRight) {
        if(index < this.maxIndex){
          index ++;
        }
        if(index <= 0) index = 1;
        x = this.leftPadding + (this.boxWidth + this.boxMarginRight) * index / 2 - this.boxMarginRight;
      }else {
        if(index > this.maxIndex){
          index = this.maxIndex - 1;
        }else{
          index --
        }
        if(index<0) index = 0;
        if(index === 0){
          x = 0;
        }else{
          x = this.leftPadding + (this.boxWidth + this.boxMarginRight) * index - this.boxMarginRight;
        }
      }
      this.currentScrollIndex = index;
      this.translateX = x;
      this.computeScrollable()
    },
    itemCLick(item, index) {
      this.currentIndex = index
      this.$emit('handleClick', item)
    },
    // 计算是否展示左右滚动按钮
    computeScrollable() {
      const scrollBar = document.querySelector('.group')
      const navSize = scrollBar.offsetWidth
      const containerSize = 1200
      const currentOffset = this.translateX;
      console.log(currentOffset,containerSize,navSize)
      if (containerSize < navSize) {
        this.scrollable.left = !!currentOffset;
        this.scrollable.right = currentOffset + containerSize < navSize;
        // if (navSize - currentOffset < containerSize) {
        //   this.navOffset = navSize - containerSize;
        // }
      }
    },
  },
  mounted() {
    const d = document.getElementById('group')
    this.leftScrollDistance = d.scrollLeft
    this.clientWidth = d.clientWidth
    this.scrollWidth = d.scrollWidth
    this.$nextTick(() => {
      this.computeScrollable()
    })
  }
}
</script>

<style lang="less" scoped>
.button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 20px;
    font-weight: 500;
    color: #999;
  }
  &:hover {
    cursor: pointer;
  }
}
.left {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.right {
  position: absolute;
  right:-40px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.item {
  flex-shrink: 0;
  width: 100px;
  height: 36px;
  margin-right: 13px;
  background: #DEDEDE;
  border-radius: 18px;
  line-height: 36px;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  cursor: pointer;
}
.is_active {
  background: #B03945;
  color: #FFFFFF;
}
.group {
  float: left;
  display:flex;
  align-items: center;
  justify-content: flex-start;
  transition: transform 0.5s ease;
  &::-webkit-scrollbar {
    display: none;
  }
}
.scroll-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/FBAWarehouseSelect.vue